<template>
<div class="rate-wrapper">
  <template v-if="!rateState">
    <span class="rate-text">以上内容是否对您有帮助：</span>
    <el-rate v-model="rateVal"
      show-text
      :texts="['非常不满意', '不满意', '一般', '比较满意', '非常满意']"
      @change="addRate()"/>
  </template>
  <template v-else>
    <img class="state-icon" src="~static/images/open/right-icon.svg"/>
    <span class="prompt-text">提交成功，感谢您的反馈！</span>
  </template>
</div>
</template>

<script>
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import axios from 'axios'

@Component
export default class DocRate extends Vue {
  rateVal = 0
  rateState = false

  @Watch('$route')
  initRate () {
    this.rateState = false
    this.rateVal = 0
  }

  resetRate () {
    this.rateVal = 0
  }

  async addRate () {
    const params = {
      doc_url: window.location.href,
      rate: this.rateVal,
      remark: ''
    }
    const res = await axios({ url: '/api/doc/rate', method: 'POST', data: params })
    if (res.data && res.data.result === 'ok') {
      this.resetRate()
      this.rateState = true
    }
  }
}
</script>

<style lang="scss" scoped>
.rate-wrapper {
  display: flex;
  align-items: center;
  padding: 35px 0;
  margin: 30px 50px 0;
  border-top: 1px solid #E7E9EB;
  .state-icon {
    margin-right: 4px;
    width: 18px;
    height: 18px;
  }
  .rate-text {
    font-size: 15px;
    font-weight: bold;
    color: initial;
  }
  .prompt-text {
    font-size: 15px;
  }
  ::v-deep .el-dialog {
    width: 400px;
  }
  ::v-deep .el-rate {
    display: flex;
    align-items: center;
  }
  ::v-deep .el-rate__text {
    margin-left: 0.5em;
  }
}
</style>
